import React from 'react'
import EmptyPageHolder from './EmptyPageHolder'

function NotFound() {
  return (
    <div>
      <EmptyPageHolder/>
    </div>
  )
}

export default NotFound